import { Icon, SVGIconList } from '@/design-system/components/icons/Icon';
import { H5, TextBody, TextCaption } from '@/design-system/components/typography';
import { SxProp, View } from 'dripsy';
import { t } from 'i18next';
import LandingBPShadow from '../../../../assets/svg/LandingBPShadow.svg';

interface BillPaymentLandingItemProps {
  title: string;
  description: string;
  iconName: SVGIconList | string;
  sx?: SxProp;
  titleSx?: SxProp;
  descriptionSx?: SxProp;
}

export const BillPaymentLandingItem: React.FC<BillPaymentLandingItemProps> = ({
  title,
  description,
  iconName,
  sx,
  titleSx,
  descriptionSx
}) => {
  const { container, body, viewImageWrapper, viewContent, textTitle, textDescription, textPlaceInstruction, viewPlaceInstructionWrapper } =
    styles;

  return (
    <View sx={{ ...container, ...sx }}>
      <View sx={viewImageWrapper}>
        <LandingBPShadow height={'100%'} width={'100%'} preserveAspectRatio={'none'} />
      </View>
      <View sx={viewContent}>
        <View sx={body}>
          <H5 bold sx={textTitle}>
            {title}
          </H5>
          <TextBody sx={textDescription}>{description}</TextBody>
          <View sx={viewPlaceInstructionWrapper}>
            <TextCaption sx={textPlaceInstruction}>{t('global-bill-payment::landing.title--place-instruction')}</TextCaption>
            <Icon name="arrowRightCircle" width={20} height={20} color={'#DC9B32'} />
          </View>
        </View>
        <Icon name={iconName as SVGIconList} width={80} height={80} />
      </View>
    </View>
  );
};

const styles: Record<string, SxProp> = {
  container: {
    width: '100%',
    height: '$50',

    shadowColor: '#000000',
    shadowOffset: {
      width: 0,
      height: 2
    },
    shadowOpacity: 0.15,
    shadowRadius: 8,
    elevation: 5,
    borderRadius: 10,
    px: '$10',
    overflow: 'hidden'
  },
  body: {
    flex: 1
  },
  viewImageWrapper: {
    position: 'absolute',
    left: '$0',
    top: '$0',
    right: '$0',
    bottom: '$0',
    zIndex: 0
  },
  viewContent: {
    flexDirection: 'row',
    alignItems: 'center',
    flex: 1
  },
  textTitle: {
    mb: '$3',
    color: '$secondary'
  },
  textDescription: {
    mb: '$3'
  },
  textPlaceInstruction: {
    color: '#DC9B32',
    mr: 6
  },
  viewPlaceInstructionWrapper: {
    flexDirection: 'row',
    alignItems: 'center'
  }
};
